// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QWf1","colBig":"styles_colBig__jvgZ_","colSmall":"styles_colSmall__1mz-R"};